import ExcelJS from 'exceljs';
import moment from 'moment';

import {
  Concentration,
  DebtorConcentration,
  FundsConcentration,
} from './types';

export const exportToXlsx = async (
  concentrations?: DebtorConcentration,
  fundsConcentrations?: FundsConcentration,
) => {
  if (!concentrations || !fundsConcentrations) return;
  const data = {
    debtor: {
      byCompany: concentrations.debtor.byCompany,
      bySector: concentrations.debtor.bySector,
      bySalesSegment: concentrations.debtor.bySalesSegment,
    },
    client: {
      byCompany: concentrations.client.byCompany,
      bySector: concentrations.client.bySector,
      bySalesSegment: concentrations.client.bySalesSegment,
    },
    funds: fundsConcentrations,
  };

  const workbook = new ExcelJS.Workbook();

  const addDataToWorksheet = (
    worksheet: ExcelJS.Worksheet,
    dataArray: Concentration[],
    title: string,
    rows: { key: string; label: string }[],
  ) => {
    worksheet.addRow([title]);
    worksheet.addRow([]);

    worksheet.addRow(rows.map((row) => row.label));

    dataArray.forEach((item) => {
      worksheet.addRow(rows.map((row) => item[row.key as keyof Concentration]));
    });

    const titleRow = worksheet.getRow(1);
    titleRow.font = { bold: true, size: 14 };
    titleRow.getCell(1).fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'FFE0E0E0' },
    };

    const headerRow = worksheet.getRow(3);
    headerRow.font = { bold: true };
    headerRow.getCell(1).fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'FFF0F0F0' },
    };
    headerRow.getCell(2).fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'FFF0F0F0' },
    };

    worksheet.getColumn(1).width = 30;
    worksheet.getColumn(2).width = 15;
  };

  const worksheets = [
    {
      name: 'debtor-byCompany',
      data: data.debtor.byCompany,
      title: 'Concentraciones por Deudor - Por Empresa',
      rows: [
        { key: 'name', label: 'Nombre' },
        { key: 'value', label: 'Valor' },
        { key: 'salesSegment', label: 'Segmento de Ventas' },
        { key: 'economicSegment', label: 'Actividad Económica' },
      ],
    },
    {
      name: 'debtor-bySector',
      data: data.debtor.bySector,
      title: 'Concentraciones por Deudor - Por Sector',
      rows: [
        { key: 'name', label: 'Nombre' },
        { key: 'value', label: 'Valor' },
      ],
    },
    {
      name: 'debtor-bySalesSegment',
      data: data.debtor.bySalesSegment,
      title: 'Concentraciones por Deudor - Por Segmento de Ventas',
      rows: [
        { key: 'name', label: 'Nombre' },
        { key: 'value', label: 'Valor' },
      ],
    },
    {
      name: 'client-byCompany',
      data: data.client.byCompany,
      title: 'Concentraciones por Cliente - Por Empresa',
      rows: [
        { key: 'name', label: 'Nombre' },
        { key: 'value', label: 'Valor' },
        { key: 'salesSegment', label: 'Segmento de Ventas' },
        { key: 'economicSegment', label: 'Actividad Económica' },
      ],
    },
    {
      name: 'client-bySector',
      data: data.client.bySector,
      title: 'Concentraciones por Cliente - Por Sector',
      rows: [
        { key: 'name', label: 'Nombre' },
        { key: 'value', label: 'Valor' },
      ],
    },
    {
      name: 'client-bySalesSegment',
      data: data.client.bySalesSegment,
      title: 'Concentraciones por Cliente - Por Segmento de Ventas',
      rows: [
        { key: 'name', label: 'Nombre' },
        { key: 'value', label: 'Valor' },
      ],
    },
  ];

  worksheets.forEach(({ name, data: worksheetData, title, rows }) => {
    if (worksheetData && worksheetData.length > 0) {
      const worksheet = workbook.addWorksheet(name);
      addDataToWorksheet(worksheet, worksheetData, title, rows);
    }
  });

  const buffer = await workbook.xlsx.writeBuffer();

  const blob = new Blob([buffer], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = `concentraciones_${moment().format('YYYY-MM-DD')}.xlsx`;
  link.click();
  window.URL.revokeObjectURL(url);
};
